/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMoodSad = createReactComponent("outline", "mood-sad", "IconMoodSad", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 10l.01 0", "key": "svg-1" }], ["path", { "d": "M15 10l.01 0", "key": "svg-2" }], ["path", { "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0", "key": "svg-3" }]]);

export { IconMoodSad as default };
//# sourceMappingURL=IconMoodSad.mjs.map
